import { ComponentProps } from 'react'
import TableRow from '@mui/material/TableRow'
import { StyledTableRow } from '../../../../components/Support/CustomElements'
import * as React from 'react'
import { useSortableTableRow } from './useSortableTableRow'
import { useIsDarkMode } from '../../../hooks/useIsDarkMode'

export type SortableTableRowProps = ComponentProps<typeof TableRow> & {
    id: string
    disabled?: boolean
}

export const SortableTableRow = ({
    children,
    highlighted,
    ...props
}: SortableTableRowProps & { highlighted?: boolean }) => {
    const isDarkMode = useIsDarkMode()
    const sortableTableRowProps = useSortableTableRow({ ...props, highlighted })
    const highlightColor = isDarkMode ? 'rgba(81, 179, 255, 0.25)' : 'rgba(81, 179, 255, 0.15)'

    return (
        <StyledTableRow
            hover
            tabIndex={-1}
            {...sortableTableRowProps}
            style={{
                ...sortableTableRowProps.style,
                ...(highlighted
                    ? {
                          backgroundColor: highlighted ? highlightColor : 'transparent',
                          transition: 'background-color 1.5s ease',
                      }
                    : {}),
            }}
        >
            {children}
        </StyledTableRow>
    )
}
